// Section 19: Harsh winter. 12% per season, Winter bias. For the season it strikes: warmth need
// 1.5x, illness 1.3x, forage 0. Foreshadowed half the time. No choice.
// Constants: config.events['harsh-winter'], config.eventDeck.foreshadowShare.
import type { Config } from '../../config';
import {
  effectDelta,
  effectParamModifiers,
  eventEntry,
  eventTurn,
} from '../../core/content-helpers';
import { defineEvent } from '../../core/registry';

export function harshWinter(config: Config) {
  const c = config.events['harsh-winter'];
  return defineEvent({
    id: 'harsh-winter',
    label: 'Harsh winter',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['winter'],
    foreshadow: { chance: config.eventDeck.foreshadowShare },
    ledgerTag: null,
    weight: () => c.baseChance,
    text: () => eventEntry('harsh-winter', { warmth: c.warmthMul, illness: c.illnessMul }),
    apply: (ctx) => [
      effectDelta('harsh-winter', 'cold', eventTurn(ctx) + 1, 1, {
        warmthMul: c.warmthMul,
        illnessMul: c.illnessMul,
        forageMul: c.forageMul,
      }),
    ],
    choices: [],
    modifierTargets: ['demand', 'illnessRisk', 'output'],
    modifiers: effectParamModifiers,
  });
}
